'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g fill-rule="evenodd"><mask id="-b-11280" fill="#fff"><path d="M11 2c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9m0 20C4.935 22 0 17.065 0 11S4.935 0 11 0s11 4.935 11 11-4.935 11-11 11M9.5 7a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zm1.5 9.25c-.69 0-1.25-.56-1.25-1.25v-4a1.25 1.25 0 0 1 2.5 0v4c0 .69-.56 1.25-1.25 1.25z"/></mask><g mask="url(#-b-11280)"><path d="M0 0h22v22H0z"/></g></g><!-- Filename: sourceSvg/notifications/information.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 22 22'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};